import React from "react";
import { Link } from "react-router-dom";
import Navigation from "../../components/navigation";
import "./index.scss";

const systems = ["hangul"];

const Korean = () => {
  return (
    <>
      <Navigation />
      <ul className="korean">
        {systems.map((system, i) => (
          <li key={`${system}_${i}`}>
            <Link
              className="link"
              to={`/korean/${system}`}
              style={{
                height: `${100 / systems.length}vh`,
                lineHeight: `${100 / systems.length}vh`,
              }}
            >
              <span>{system}</span>
              <span className="dot"></span>
            </Link>
            <div className="homepage-divider" />
          </li>
        ))}
      </ul>
    </>
  );
};

export default Korean;
